import { render, staticRenderFns } from "./h5.vue?vue&type=template&id=021a76e4&scoped=true"
import script from "./h5.vue?vue&type=script&lang=js"
export * from "./h5.vue?vue&type=script&lang=js"
import style0 from "./h5.vue?vue&type=style&index=0&id=021a76e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a76e4",
  null
  
)

export default component.exports